export class BankModel {
    id: number;
    code: number;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/bank.model.ts